// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"b0ef7b6e","459":"049283fc","715":"3272fd28","774":"c0a8a2f7","858":"5232b15c","883":"4ebd21de"}[chunkId] + ".chunk.js";
};